import React, { Fragment } from "react";
import {
  Typography,
  TextField,
  Grid,
  InputLabel,
  Autocomplete,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Input,
  CircularProgress,
} from "@mui/material";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  li: {
    color: "blue",
    "&[aria-disabled=true]": {
      backgroundColor: "lightgreen",
    },
  },
}));

export const ReceiptConvert = (props) => {
  const {
    columns,
    dateRangeRq,
    receiptsRq,
    receiptsRqLoaded,
    receiptsRqSelected,
    handleChangeRangeDateRq,
    handleChangeReceiptsRq,
    handleChangeReceiptsRqSelected,
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.paper}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography component="h4" style={{ textAlign: "center" }}>
            Load RD receipts from a given date and select the receipts to
            convert
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              value={dateRangeRq[0]}
              renderInput={(props) => (
                <TextField
                  {...props}
                  fullWidth
                  label="Select start date"
                  variant="standard"
                />
              )}
              onChange={(date) =>
                handleChangeRangeDateRq({
                  target: {
                    name: "start_date",
                    value: date,
                  },
                })
              }
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              value={dateRangeRq[1]}
              renderInput={(props) => (
                <TextField
                  {...props}
                  fullWidth
                  label="Select end date"
                  variant="standard"
                />
              )}
              onChange={(date) =>
                handleChangeRangeDateRq({
                  target: {
                    name: "end_date",
                    value: date,
                  },
                })
              }
            />
          </LocalizationProvider>
        </Grid>
        {receiptsRq.length ? (
          <Grid item xs={12} sm={12}>
            <InputLabel shrink id="orders">
              Receipts
            </InputLabel>
            <Autocomplete
              fullWidth
              multiple
              disablePortal
              size="small"
              name="receipts"
              options={receiptsRq}
              getOptionLabel={(option) =>
                `Receipt #${option.receiptNumber} $${option.sales} (${
                  option.purchaseDate
                }) ${option.converted ? " - converted" : ""}`
              }
              getOptionDisabled={(option) => option.converted}
              isOptionEqualToValue={(option, value) =>
                option.receiptNumber === value.receiptNumber
              }
              renderInput={(params) => (
                <TextField {...params} size="small" variant="standard" />
              )}
              onChange={(e, value) => handleChangeReceiptsRq(e, value)}
              helpertext="Select the receipts to convert."
              value={receiptsRqSelected}
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={12}>
            <InputLabel shrink id="orders">
              Receipts
            </InputLabel>
            {receiptsRqLoaded ? (
              <>There are no receipts to convert yet.</>
            ) : (
              <CircularProgress />
            )}
          </Grid>
        )}
        {receiptsRqSelected.length ? (
          <>
            <Grid item xs={12} sm={12}></Grid>
            <Grid item xs={12} sm={12}>
              <Typography component="h4" style={{ textAlign: "center" }}>
                Optionally use the grid below to assign a custom name to a
                receipt
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  size="small"
                  classes={{ root: classes.customTable }}
                >
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={`header-${column.id}`}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {receiptsRqSelected.map((row, index) => (
                      <TableRow hover tabIndex={-1} key={`row-${index}`}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={`column-${column.id}-row-${index}`}
                              style={{
                                maxWidth: column.id === "name" ? 350 : "auto",
                              }}
                            >
                              {column.exposed
                                ? {
                                    input: (
                                      <Input
                                        fullWidth
                                        name={`${column.id}-${index}`}
                                        value={value}
                                        onChange={
                                          handleChangeReceiptsRqSelected
                                        }
                                      />
                                    ),
                                  }[column.exposedAs || "input"]
                                : typeof value === "boolean"
                                ? "" + value
                                : typeof value === "object" && value === null
                                ? "N/A"
                                : value || 0}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </>
        ) : (
          <></>
        )}
      </Grid>
    </div>
  );
};

export default ReceiptConvert;
